/**
 * Cached DOM element references for the entire application
 * All elements are queried once at module load time
 */
export const el = {
  // Status & Market
  status: document.getElementById('status') as HTMLElement | null,
  themeSel: document.getElementById('themeSel') as HTMLSelectElement | null,
  market: document.getElementById('market') as HTMLElement | null,
  btn: document.getElementById('btn') as HTMLButtonElement | null,
  slugInput: document.getElementById('slug') as HTMLInputElement | null,
  marketSelect: document.getElementById('marketSelect') as HTMLSelectElement | null,
  
  // Orderbook
  booksRow: document.getElementById('booksRow') as HTMLElement | null,
  assetSelect: document.getElementById('assetSelect') as HTMLSelectElement | null,
  
  // Team Selection
  teamBtnA: document.getElementById('teamBtnA') as HTMLButtonElement | null,
  teamBtnB: document.getElementById('teamBtnB') as HTMLButtonElement | null,
  teamANameEl: document.getElementById('teamAName') as HTMLElement | null,
  teamBNameEl: document.getElementById('teamBName') as HTMLElement | null,
  teamAMap: document.getElementById('teamAMap') as HTMLSelectElement | null,
  teamBMap: document.getElementById('teamBMap') as HTMLSelectElement | null,
  
  // Order Form
  sideBuyBtn: document.getElementById('sideBuy') as HTMLButtonElement | null,
  sideSellBtn: document.getElementById('sideSell') as HTMLButtonElement | null,
  priceInp: document.getElementById('price') as HTMLInputElement | null,
  sizeInp: document.getElementById('size') as HTMLInputElement | null,
  maxSharesBtn: document.getElementById('maxShares') as HTMLButtonElement | null,
  add50Btn: document.getElementById('add50') as HTMLButtonElement | null,
  notionalEl: document.getElementById('notional') as HTMLElement | null,
  orderResult: document.getElementById('orderResult') as HTMLElement | null,
  
  // Quick Trade
  quickSize: document.getElementById('quickSize') as HTMLInputElement | null,
  quickLimitPanel: document.getElementById('quickLimitPanel') as HTMLElement | null,
  quickLimitBuySize: document.getElementById('quickLimitBuySize') as HTMLInputElement | null,
  quickLimitSellSize: document.getElementById('quickLimitSellSize') as HTMLInputElement | null,
  quickLimitMaxSell: document.getElementById('quickLimitMaxSell') as HTMLButtonElement | null,
  quickLimitCancelAll: document.getElementById('quickLimitCancelAll') as HTMLButtonElement | null,
  
  // Flash Messages
  flashEl: document.getElementById('flash') as HTMLElement | null,
  
  // Orders
  ordersEl: document.getElementById('orders') as HTMLElement | null,
  refreshOrdersBtn: document.getElementById('refreshOrders') as HTMLButtonElement | null,
  cancelAllBtn: document.getElementById('cancelAll') as HTMLButtonElement | null,
  
  // Positions
  positionsEl: document.getElementById('positions') as HTMLElement | null,
  refreshPositionsBtn: document.getElementById('refreshPositions') as HTMLButtonElement | null,
  
  // Funds
  fundsEl: document.getElementById('funds') as HTMLElement | null,
  refreshFundsBtn: document.getElementById('refreshFunds') as HTMLButtonElement | null,
  
  // Orderbook Status
  refreshBookBtn: document.getElementById('refreshBook') as HTMLButtonElement | null,
  obStatus: document.getElementById('obStatus') as HTMLElement | null,
  
  // Activity
  activityEl: document.getElementById('activity') as HTMLElement | null,
  refreshActivityBtn: document.getElementById('refreshActivity') as HTMLButtonElement | null,
};


